// The shipping label from the return flow designs: sender/recipient block, a
// datamatrix, the service bar and the tracking barcode.
const barcode = buildBarcode()
const datamatrix = buildDatamatrix()

interface LabelSheetProps {
  className?: string
  // Draws the label as empty paper, for a label that does not exist yet.
  blank?: boolean
}

export const LabelSheet = ({ className, blank = false }: LabelSheetProps) => {
  const ink = blank ? '#D1D5DB' : '#030712'
  const text = blank ? '#E5E7EB' : '#E5E7EB'

  return (
    <svg
      viewBox="0 0 180 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="179"
        height="239"
        rx="4"
        fill="white"
        stroke="#E5E7EB"
      />

      <rect x="14" y="16" width="56" height="4" rx="2" fill={text} />
      <rect x="14" y="24" width="44" height="4" rx="2" fill={text} />
      <rect x="14" y="32" width="50" height="4" rx="2" fill={text} />
      <rect x="104" y="16" width="48" height="4" rx="2" fill={text} />
      <rect x="114" y="24" width="38" height="4" rx="2" fill={text} />

      <rect x="14" y="48" width="152" height="1" fill="#F3F4F6" />

      <g>
        {datamatrix.map((cell) => (
          <rect
            key={`${cell.x}-${cell.y}`}
            x={14 + cell.x * 6}
            y={58 + cell.y * 6}
            width="6"
            height="6"
            fill={ink}
          />
        ))}
      </g>

      <rect x="74" y="62" width="76" height="7" rx="1" fill={ink} />
      <rect x="74" y="76" width="54" height="4" rx="2" fill={text} />
      <rect x="74" y="86" width="64" height="4" rx="2" fill={text} />

      <rect x="14" y="112" width="124" height="16" fill={ink} />
      <rect x="144" y="112" width="22" height="16" fill={ink} />

      <g>
        {barcode.map((bar) => (
          <rect
            key={bar.x}
            x={bar.x}
            y="140"
            width={bar.width}
            height="54"
            fill={ink}
          />
        ))}
      </g>

      <rect x="14" y="206" width="90" height="4" rx="2" fill={text} />
      <rect x="14" y="216" width="68" height="4" rx="2" fill={text} />
    </svg>
  )
}

function buildBarcode(): { x: number; width: number }[] {
  const widths = [
    2, 1, 3, 1, 1, 2, 4, 1, 2, 1, 3, 2, 1, 1, 2, 3, 1, 2, 1, 3, 2, 1, 2, 1
  ]
  const bars: { x: number; width: number }[] = []
  let x = 14
  for (const width of widths) {
    bars.push({ x, width })
    x += width + 3
  }
  return bars
}

function buildDatamatrix(): { x: number; y: number }[] {
  // Fixed bit rows so the pattern is stable between renders.
  const rows = [
    0b1010101, 0b1101011, 0b1001101, 0b1110010, 0b1011011, 0b1100101, 0b1111111
  ]
  const cells: { x: number; y: number }[] = []
  rows.forEach((row, y) => {
    for (let x = 0; x < 7; x++) {
      if ((row >> (6 - x)) & 1) cells.push({ x, y })
    }
  })
  return cells
}
